class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

    const facetDetailsElements = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const matchesIndex = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
    };
    const facetsToRender = Array.from(facetDetailsElements).filter((element) => !matchesIndex(element));
    const countsToRender = Array.from(facetDetailsElements).find(matchesIndex);

    facetsToRender.forEach((element) => {
      document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            const noJsElements = document.querySelectorAll('.no-js-list');
            noJsElements.forEach((el) => el.remove());
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  connectedCallback() {
    this.minRange  = this.querySelector('.price-range-slider__min');
    this.maxRange  = this.querySelector('.price-range-slider__max');
    this.minHidden = this.querySelector('.price-range-slider__hidden-min');
    this.maxHidden = this.querySelector('.price-range-slider__hidden-max');
    this.minLabel  = this.querySelector('.price-range-slider__label-min');
    this.maxLabel  = this.querySelector('.price-range-slider__label-max');
    this.fill      = this.querySelector('.price-range-slider__track-fill');

    // Non-linear scale: slider 0-100, midpoint (50) = €300
    // curve: price = (pos/100)^EXP * 1000, midpoint check: (0.5)^EXP * 1000 = 300
    this.SLIDER_MAX = 100;
    this.PRICE_MAX  = 1000;
    this.EXP        = Math.log(300 / 1000) / Math.log(0.5); // ≈ 1.737

    // Sync slider positions from hidden input euro values (set by Liquid on page load)
    const minEuros = parseFloat(this.minHidden.value) || 0;
    const maxEuros = parseFloat(this.maxHidden.value) || this.PRICE_MAX;
    this.minRange.value = this.priceToSlider(minEuros);
    this.maxRange.value = this.priceToSlider(maxEuros);

    this.minRange.addEventListener('input',  () => this.onInput());
    this.maxRange.addEventListener('input',  () => this.onInput());
    this.minRange.addEventListener('change', () => this.onCommit());
    this.maxRange.addEventListener('change', () => this.onCommit());

    this.syncUI();
    this.updateTrackFill();
  }

  priceToSlider(euros) {
    if (euros <= 0) return 0;
    if (euros >= this.PRICE_MAX) return this.SLIDER_MAX;
    return Math.round(Math.pow(euros / this.PRICE_MAX, 1 / this.EXP) * this.SLIDER_MAX);
  }

  sliderToPrice(pos) {
    if (pos <= 0) return 0;
    if (pos >= this.SLIDER_MAX) return this.PRICE_MAX;
    return Math.round(Math.pow(pos / this.SLIDER_MAX, this.EXP) * this.PRICE_MAX);
  }

  onInput() {
    if (Number(this.minRange.value) > Number(this.maxRange.value)) {
      this.minRange.value = this.maxRange.value;
    }
    this.syncUI();
    this.updateTrackFill();
  }

  onCommit() {
    this.onInput();
    const minPrice = this.sliderToPrice(Number(this.minRange.value));
    const maxPos   = Number(this.maxRange.value);
    this.minHidden.value = minPrice === 0 ? '' : minPrice;
    this.maxHidden.value = maxPos >= this.SLIDER_MAX ? '' : this.sliderToPrice(maxPos);
    this.minHidden.dispatchEvent(new Event('change', { bubbles: true }));
  }

  syncUI() {
    const minPrice = this.sliderToPrice(Number(this.minRange.value));
    const maxPos   = Number(this.maxRange.value);
    const maxPrice = this.sliderToPrice(maxPos);
    if (this.minLabel) this.minLabel.textContent = minPrice;
    if (this.maxLabel) this.maxLabel.textContent = maxPos >= this.SLIDER_MAX ? this.PRICE_MAX + '+' : maxPrice;
  }

  updateTrackFill() {
    const minPos = Number(this.minRange.value);
    const maxPos = Number(this.maxRange.value);
    if (this.fill) {
      this.fill.style.left  = (minPos / this.SLIDER_MAX * 100) + '%';
      this.fill.style.width = ((maxPos - minPos) / this.SLIDER_MAX * 100) + '%';
    }
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* ============================================================
   Random sort — client-side Fisher-Yates shuffle
   Fires on page load and after AJAX filter/sort updates only
   ============================================================ */
(function () {
  const GRID_SELECTOR = '.product-grid';
  const SORT_PARAM    = 'random';
  let observer        = null;
  let shufflePending  = false;

  function isRandomSort() {
    return new URLSearchParams(window.location.search).get('sort_by') === SORT_PARAM;
  }

  function shuffleGrid() {
    const grid = document.querySelector(GRID_SELECTOR);
    if (!grid) return;
    // Pause observer while shuffling to avoid self-triggering
    if (observer) observer.disconnect();
    const items = Array.from(grid.children);
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      grid.appendChild(items[j]);
      items.splice(j, 1);
    }
    // Resume observer after shuffle
    const container = document.getElementById('ProductGridContainer');
    if (observer && container) observer.observe(container, { childList: true, subtree: false });
    shufflePending = false;
  }

  function onGridMutation(mutations) {
    if (!isRandomSort() || shufflePending) return;
    // Only react to mutations that add new product nodes (AJAX reload), not attribute changes
    const hasNewNodes = mutations.some(m => m.addedNodes.length > 0);
    if (!hasNewNodes) return;
    shufflePending = true;
    setTimeout(shuffleGrid, 80);
  }

  function init() {
    if (isRandomSort()) shuffleGrid();

    const container = document.getElementById('ProductGridContainer');
    if (container) {
      observer = new MutationObserver(onGridMutation);
      observer.observe(container, { childList: true, subtree: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
